import type { NodeDto, UpdateNodeInput } from "@mmm/contracts";
import { updateNode } from "./commands.js";

/**
 * updateNode's contract requires every LayoutFields (docs/10-service-
 * contracts.md's UpdateNodeRequest), not a partial patch — this fills in the
 * node's current values for anything not being changed, so call sites can
 * still express "just move it" or "just recolor it".
 */
export function updateNodeFields(node: NodeDto, patch: Partial<Omit<UpdateNodeInput, "nodeId">>) {
  return updateNode({
    nodeId: node.id,
    title: node.title,
    x: node.x,
    y: node.y,
    width: node.width,
    height: node.height,
    zIndex: node.zIndex,
    color: node.color,
    collapsed: node.collapsed,
    ...patch,
  });
}
